import React from 'react';
import FrameImage from '../../components/frameImage';
import { organizingDonations } from '../../components/image-router';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import './contact.scss';
import { useTranslation } from 'react-i18next';


const Contact = () => {
    const { t } = useTranslation();
    return (
        <>
            <div>
                <FrameImage image={organizingDonations} section="contact" />
            </div>
            <div className='containerContact'>
                <div className='containerLeftInfo'>
                    <div className='title-content'>
                        {t('contact.employment')}
                    </div>
                    <div className='info-content'>
                        {t('contact.employmentInfo')}
                        <div>&nbsp;</div>
                        {t('contact.instagramInfo')}
                    </div>
                    <div className='title-content'>
                        {t('contact.questions')}
                    </div>
                    <div className='info-content'>
                        {t('contact.mailInfo')}
                        <div>&nbsp;</div>
                        {t('contact.email')}
                    </div>

                </div>
                <div className='containerRightInfoImage'>
                    <div className='form-title'>
                        {t('contact.formTitle')}
                    </div>
                    <div className='textfieldForm'>
                        <TextField id="outlined-basic" label={t('contact.fullName')} variant="outlined" style={{ width: 370 }} />
                    </div>
                    <div className='textfieldForm'>
                        <TextField id="outlined-basic" label={t('contact.phone')} variant="outlined" style={{ width: 370 }} />
                    </div>
                    <div className='textfieldForm'>
                        <TextField id="outlined-basic" label={t('contact.emailLabel')} variant="outlined" style={{ width: 370 }} />
                    </div>
                    <div className='textfieldForm'>
                        <TextField id="outlined-basic" label={t('contact.city')} variant="outlined" style={{ width: 370 }} />
                    </div>
                    <div className='textfieldForm'>
                        <TextField
                            id="outlined-multiline-static"
                            label={t('contact.message')}
                            className="modal__textarea"
                            multiline
                            minRows={6}
                            maxRows={6}
                            defaultValue=""
                            variant="outlined"
                            style={{ width: 370 }}
                        />
                    </div>
                    <div>
                        <Box textAlign='center'>
                            <Button variant="contained" color="success" className='button'>
                                {t('contact.submit')}
                            </Button>
                        </Box>
                    </div>

                </div>
            </div>
            <div className='directiveFrase'>
                {t('contact.directiveIntro')}
            </div>
            <div className='directiveContent'>

                <div className='containerDirectiveInfo'>
                    <div className='title-content'>
                        {t('contact.directive')}
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Fernando Bolaños Ramos
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.president')}
                        </div>
                        <div className='directiveInfo'>
                            fbolanos@svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Manuel Parés
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.vicePresident')}
                        </div>
                        <div className='directiveInfo'>
                            mpares@svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Jose "Cheo"  Garcia
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.firstSecretary')}
                        </div>
                        <div className='directiveInfo'>
                            info@svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Jorge Jerez
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.techFundraising')}
                        </div>
                        <div className='directiveInfo'>
                            jjerez@svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Gerardo Guzmán
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.accounting')}
                        </div>
                        <div className='directiveInfo'>
                            gguzman@svdpdoral.org
                        </div>
                    </div>
                </div>
                <div className='containerDirectiveInfo'>
                    <div className='title-content'>
                        {t('contact.supportTeam')}
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Santiago Gaviria
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.foodBankDirector')}
                        </div>
                        <div className='directiveInfo'>
                            info@svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Iris Montes de Oca
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.supportNetworkCoord')}
                        </div>
                        <div className='directiveInfo'>
                            imontesdeoca @svdpdoral.org
                        </div>
                    </div>
                    <div className='directivePeople'>
                        <div className='directiveName'>
                            Isbelia Bolivar
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.firstSecretary')}
                        </div>
                        <div className='directiveInfo'>
                            sanvicentedoral@gmail.com
                        </div>
                    </div>
                    <div className='directivePeople mb-5'>
                        <div className='directiveName'>
                            Luis Reyes
                        </div>
                        <div className='directiveInfo'>
                            {t('contact.instagramCoord')}
                        </div>
                        <div className='directiveInfo'>
                            lreyes @svdpdoral.org
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-5 directionText text-center mb-3'>
                {t('contact.address')}
            </div>
            <div className='frame-contact-yellow pb-3 text-center'>
                <div className='frame-title'>
                    {t('contact.moreHelpers')}
                </div>
                <div className='frame-text'>
                    {t('contact.alwaysNeedHelp')}
                </div>
            </div>
            <div className="container">

            </div>
        </>
    );
}

export default Contact;
